import { flow, map, get, sum } from 'lodash/fp';

import containerPricing from '../container';

export default (allContainers, allItems, prop, design) => flow(
  map(cid => get(cid)(allContainers)),
  map(containerPricing(allItems, prop)),
  sum,
)(design.containers);
